import { TaxaRegulacaoAPI } from "@/api/financeiro/taxa-regulacao.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";

const api = new TaxaRegulacaoAPI();

const listReceitas = (body: {
  cpfCnpj: string;
  page: number;
  size: number;
  ascendingSort: boolean;
  sort: string[];
}): AxiosObservable<any> => api.listReceitas(body);

const listReceitasSaneamento = (body: {
  cpfCnpj: string;
  page: number;
  size: number;
  ascendingSort: boolean;
  sort: string[];
}): AxiosObservable<any> => api.listReceitasSaneamento(body);

const baixarDae = (
  cpfCnpj: string,
  ids: string[],
  date: string
): AxiosObservable<any> => api.baixarDae(cpfCnpj, ids, date);

export default {
  listReceitas,
  listReceitasSaneamento,
  baixarDae,
};
